/**
 * TabContentHeader – Standard header for Client Details tab content.
 * Slimmer than PageHeader, suited for tab-level titles.
 *
 * Props:
 *   title        {string}  Required. Tab section title.
 *   description  {string}  Optional. Subtitle / description.
 *   actions      {node}    Optional. Right-side actions (buttons, etc.).
 *   children     {node}    Optional. Extra content.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';

const TabContentHeader = ({
  title,
  description,
  actions,
  children,
  sx = {},
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexWrap: 'wrap',
      gap: 2,
      mb: 3,
      ...sx,
    }}
  >
    <Box sx={{ minWidth: 0, flex: '1 1 220px' }}>
      <Typography variant="h5" sx={{ fontWeight: 600, fontSize: '1.25rem', wordBreak: 'break-word' }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, wordBreak: 'break-word' }}>
          {description}
        </Typography>
      )}
    </Box>
    {(actions || children) && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        {actions}
        {children}
      </Box>
    )}
  </Box>
);

export default TabContentHeader;
